/* lua.js generated code 0.3.0 */

var Event = require("cocos/framework/components/event")
FriendManager = xClass("FriendManager", Event)
FriendUpdateEvents = table([1, "Update", "FRIENDUPDATEEVENTS.UPDATE"], [1, "Sync", "FRIENDUPDATEEVENTS.SYNC"])
var instance = null
FriendManager.getInstance = function () {
    var self = this
    if (!instance) {
        instance = FriendManager.new()
    }
    return instance
}
FriendManager.prototype.ctor = function () {
    var self = this
    self.bind(self)
    self.lastUpdateFriendTime = 0
    self.friendInfoSynced = false
    self.friends = table()
    self.profiles = table()
    self.levelFriends = table()
    self.likeFriendIds = table()
}
FriendManager.prototype.isFriendInfoSynced = function () {
    var self = this
    return self.friendInfoSynced
}
//-used to get friend 
FriendManager.prototype.syncNewFriendInfo = function (successCallback, failCallback) {
    var self = this
    function onGetFriendListSuccess(data) {
        var newUidList = table()
        var friendManager = FriendManager.getInstance()
        data.data.friendIds = data.data.friendIds || table()
        for (var k = 1, v = data.data.friendIds[1]; v; k++, v = data.data.friendIds[k]) {
            if (!friendManager.isFriend(v)) {
                table.insert(newUidList, v)
            }
        }
        //删除已经不是好友的用户的信息
        for (var k in self.friends) {
            var v = self.friends[k]
            if(!v){
                continue
            }
            if (!UserManager.getInstance().isFriend(v.uid)) {
                self.removeFriend(v.uid)
            }
        }
        if ($len(newUidList) > 0) {
            function onSuccess(data) {
                data.data.users = data.data.users || table()
                for (var k = 1, v = data.data.users[1]; v; k++, v = data.data.users[k]) {
                    self.setAsFriend(v, data.data.profiles[k])
                }
                if (successCallback) {
                    successCallback()
                }
            }
            function onFailed(err) {
                if (failCallback) {
                    failCallback(err)
                }
            }
            var http = FriendHttp.new(true)
            http.addEventListener(Events.kComplete, onSuccess)
            http.addEventListener(Events.kError, onFailed)
            http.load(newUidList)
        } else if (successCallback) {
            successCallback()
        }
    }
    function onGetFriendListFail(err) {
        if (failCallback) {
            failCallback(err)
        }
    }
    // onGetFriendListFail("fail")
    var http = GetFriendsHttp.new(true)
    http.addEventListener(Events.kComplete, onGetFriendListSuccess)
    http.addEventListener(Events.kError, onGetFriendListFail)
    http.load()
}
FriendManager.prototype.setFriendLiked = function (uid) {
    var self = this
    var friendUser = self.friends[uid]
    if (friendUser) {
        friendUser.haveLiked = true
    }
}
FriendManager.prototype.hasLikedUser = function (uid) {
    var self = this
    if (self.friends[uid]) {
        return self.friends[uid].haveLiked
    }
    return false
}
//-used to sync all friends
FriendManager.prototype.syncFriendInfo = function (forceRefresh, successCallback, failCallback, cancelCallback) {
    var self = this
    if (!forceRefresh && Localhost.time() - self.lastUpdateFriendTime < 30 * 60 * 1000) {
        if (successCallback) {
            successCallback()
        }
        return 
    }
    self.syncOKCallbacks = self.syncOKCallbacks || table()
    table.insert(self.syncOKCallbacks, successCallback)
    self.syncErrorCallbacks = self.syncErrorCallbacks || table()
    table.insert(self.syncErrorCallbacks, failCallback)
    self.syncCancelCallbacks = self.syncCancelCallbacks || table()
    table.insert(self.syncCancelCallbacks, cancelCallback)
    if (self.friendRefreshing) {
        return 
    }
    self.friendRefreshing = true
    function onGetFriendListSuccess() {
        function onSuccess(data) {
            cc.log("get friend info success")
            if (data.data) {
                self.lastUpdateFriendTime = Localhost.time()
                self.friendInfoSynced = true
                self.friendRefreshing = false
                self.levelFriends = table()
                data.data.users = data.data.users || table()
                for (var k = 1, v = data.data.users[1]; v; k++ , v = data.data.users[k]) {
                    self.setAsFriend(v, data.data.profiles[k])
                }
                for (var i = 1, v = self.syncOKCallbacks[1]; v; i++ , v = self.syncOKCallbacks[i]) {
                    v()
                }
                self.dispatchEvent(table([1, "name", FriendUpdateEvents.Update]))
                self.dispatchEvent(table([1, "name", FriendUpdateEvents.Sync]))
                self.syncOKCallbacks = table()
                self.syncErrorCallbacks = table()
                self.syncCancelCallbacks = table()
            }
        }
        function onFailed(err) {
            self.friendRefreshing = false
            for (var i = 1, v = self.syncErrorCallbacks[1]; v; i++, v = self.syncErrorCallbacks[i]) {
                v(err)
            }
            self.syncOKCallbacks = table()
            self.syncErrorCallbacks = table()
            self.syncCancelCallbacks = table()
        }
        function onCancel() {
            self.friendRefreshing = false
            for (var i = 1, v = self.syncCancelCallbacks[1]; v; i++, v = self.syncCancelCallbacks[i]) {
                v()
            }
            self.syncOKCallbacks = table()
            self.syncErrorCallbacks = table()
            self.syncCancelCallbacks = table()
        }
        var http = FriendHttp.new(forceRefresh)
        http.addEventListener(Events.kComplete, onSuccess)
        http.addEventListener(Events.kError, onFailed)
        http.addEventListener(Events.kCancel, onCancel)
        var friendIds = UserManager.getInstance().friendIds || table()
        http.load(friendIds)
    }
    function onGetFriendListFail(err) {
        self.friendRefreshing = false
        for (var i = 1, v = self.syncErrorCallbacks[1]; v; i++, v = self.syncErrorCallbacks[i]) {
            v(err)
        }
        self.syncOKCallbacks = table()
        self.syncErrorCallbacks = table()
        self.syncCancelCallbacks = table()
    }
    function onGetFriendListCancel() {
        self.friendRefreshing = false
        for (var i = 1, v = self.syncCancelCallbacks[1]; v; i++, v = self.syncCancelCallbacks[i]) {
            v()
        }
        self.syncOKCallbacks = table()
        self.syncErrorCallbacks = table()
        self.syncCancelCallbacks = table()
    }

    // onGetFriendListFail("failed")
    // onGetFriendListSuccess("success")
    var http = GetFriendsHttp.new(forceRefresh)
    http.addEventListener(Events.kComplete, onGetFriendListSuccess)
    http.addEventListener(Events.kError, onGetFriendListFail)
    http.addEventListener(Events.kCancel, onGetFriendListCancel)
    http.load()
}
FriendManager.prototype.reset = function () {
    var self = this
    self.friends = table()
    self.profiles = table()
    self.levelFriends = table()
}
FriendManager.prototype.setAsFriend = function (userData, profileData) {
    var self = this
    if (!userData || !profileData) {
        return
    }
    self.setAsFriendRef(UserRef.new().fromLua(userData), ProfileRef.new().fromLua(profileData))
}
FriendManager.prototype.setAsFriendRef = function (userRef, profileRef) {
    var self = this
    self.friends[userRef.uid] = userRef
    self.profiles[profileRef.uid] = profileRef
    // var topLevelId = tonumber(userRef.getTopLevelId())
    var topLevelId = userRef.getTopLevelId()
    if (!self.levelFriends[topLevelId]) {
        self.levelFriends[topLevelId] = table()
    }
    if (!table.indexOf(self.levelFriends[topLevelId], userRef.uid)) {
        table.insert(self.levelFriends[topLevelId], userRef.uid)
    }
    self.dispatchEvent(table([1, "name", FriendUpdateEvents.Update]))
}
FriendManager.prototype.removeFriend = function (uid) {
    var self = this
    uid = tostring(uid)
    self.friends[uid] = null
    self.profiles[uid] = null
    for (var _ in self.levelFriends) {
        var v = self.levelFriends[_]
        table.removeValue(v, uid)
    }
    for (var k in UserManager.getInstance().friendIds) {
        var v = UserManager.getInstance().friendIds[k]
        if (tostring(uid) === tostring(v)) {
            table.remove(UserManager.getInstance().friendIds, k)
        }
    }
    self.dispatchEvent(table(
        [1, "name", FriendUpdateEvents.Update],
        [1, "isRemoveFriend", true],
        [1, "uid", uid]
    ))
    self.dispatchEvent(table([1, "name", FriendUpdateEvents.Sync]))
}
FriendManager.prototype.updateProfile = function (profileData) {
    var self = this
    if (self.friends[profileData.uid]) {
        self.updatePropfileRef(ProfileRef.new().fromLua(profileData))
    }
}
FriendManager.prototype.updatePropfileRef = function (profileRef) {
    var self = this
    if (self.friends[uid]) {
        self.profiles[profileRef.uid] = profileRef
    }
}
FriendManager.prototype.isFriend = function (uid) {
    var self = this
    return self.friends[tonumber(uid)]
}
FriendManager.prototype.getFriendInfo = function (uid) {
    var self = this
    return [self.friends[uid], self.profiles[uid]]
}
FriendManager.prototype.getFriendsByLevel = function (levelId) {
    var self = this
    // body
    var list = self.levelFriends[levelId]
    var result = table()
    if (list) {
        for (var k = 1, v = list[1]; v; k++, v = list[k]) {
            var user = self.friends[v]
            var profile = self.profiles[v]
            if (user && profile) {
                table.insert(result, table([1, "user", user], [1, "profile", profile]))
            }
        }
        table.sort(result, function (a, b) {
            return a.user.getTotalStar() < b.user.getTotalStar()
        })
        if ($len(result) > 0) {
            return result
        }
    }
    return null
}
FriendManager.prototype.getFriends = function () {
    var self = this
    return [self.friends, self.profiles]
}
FriendManager.prototype.getFriendCount = function () {
    var self = this
    // WARN: maybe multi result
    return table.nums(self.friends)
}
FriendManager.prototype.syncFromLua = function (src, profiles, snsFriendIds) {
    var self = this
    self.snsFriendIds = table()
    self.friends = table()
    if (snsFriendIds) {
        for (var _ in snsFriendIds) {
            var v = snsFriendIds[_]
            self.snsFriendIds[tostring(v)] = true
        }
    }
    var list = table()
    if (profiles != null) {
        for (var i = 1, v = profiles[1]; v; i++, v = profiles[i]) {
            if (v) {
                list[v.uid] = ProfileRef.create().fromLua(v)
            }
            self.profiles[v.uid] = ProfileRef.create().fromLua(v)
        }
    }
    for (var i = 1, v = src[1]; v; i++, v = src[i]) {
        var f = UserRef.new()
        f.fromLua(v)
        var profile = list[f.uid]
        if (profile) {
            f.name = he.HeDisplayUtil.urlDecode(profile.name || "")
            f.headUrl = profile.headUrl
            f.snsId = profile.snsId
        }
        self.friends[f.uid] = f
    }
    self.syncFromLuaFinish = true
}
FriendManager.prototype.getSyncFinish = function () {
    var self = this
    return self.syncFromLuaFinish
}
FriendManager.prototype.encode = function () {
    var self = this
    var dst = table()
    for (var uid in self.friends) {
        var v = self.friends[uid]
        dst[uid] = v.encode()
    }
    return dst
}
FriendManager.prototype.queryFriend = function (code, onSuccess, onFail, onCancel) {
    var self = this
    function onFinish(data) {
        onSuccess(data)
    }
    function onError(err) {
        onFail(err)
    }
    function onCancelled() {
        onCancel()
    }
    var http = QueryUserHttp.new(true)
    http.addEventListener(Events.kComplete, onFinish)
    http.addEventListener(Events.kError, onError)
    http.addEventListener(Events.kCancel, onCancelled)
    http.load(code)
}
FriendManager.prototype.addFriend = function (user, profile) {
    var self = this
    UserManager.getInstance().addFriendIds(table([0, user.uid]))
    FriendManager.getInstance().setAsFriendRef(user, profile)
    self.dispatchEvent(table([1, "name", FriendUpdateEvents.Sync]))
}
FriendManager.prototype.sendFriendRequest = function (uid, onSuccess, onFail, onCancel) {
    var self = this
    self.sendFriendRequests(table([0, uid]), onSuccess, onFail, onCancel)
}
FriendManager.prototype.sendFriendRequests = function (uids, onSuccess, onFail, onCancel) {
    var self = this
    function onFinish(data) {
        onSuccess(data)
    }
    function onError(error) {
        onFail(error)
    }
    function onCancelled() {
        onCancel()
    }
    var http = SendMsgHttp.new(true)
    http.addEventListener(Events.kComplete, onFinish)
    http.addEventListener(Events.kError, onError)
    http.addEventListener(Events.kCancel, onCancelled)
    http.load(5, uids, 0)
}
FriendManager.prototype.queryUidByPhones = function () {
    var self = this
    // body
}
FriendManager.prototype.getActiveFriendCount = function () {
    var self = this
    var count = 0
    if (type(self.friends) === "table") {
        var time = Localhost.time()
        for (var k in self.friends) {
            var v = self.friends[k]
            if (v && type(v.getUpdateTime) === "function") {
                var friendt = tonumber(v.getUpdateTime())
                if (friendt) {
                    if (time - friendt < 604800000) {
                        count = count + 1
                    }
                }
            }
        }
    }
    return count
}
FriendManager.prototype.cacheProfileURL = function () {
    let self = this
    self.cacheHeadURL = table()
    for (let k in self.profiles) {
        let v = self.profiles[k]
        if ($null(v)) continue
        self.cacheHeadURL[tostring(v.headUrl)] = true
    }
}
FriendManager.prototype.isFriendHeadURL = function (url) {
    let self = this
    if (type(self.cacheHeadURL) === "table") {
        return self.cacheHeadURL[url]
    }
}